import * as React from 'react';
import { Label, LabelProps } from 'reactstrap';

export interface LabelCustomProps extends LabelProps {
  mandatory?: boolean;
}

export const LabelCustom = (props: LabelCustomProps) => {
  const {
    children,
    mandatory,
    ...rest
  } = props;
  return (
    <Label className="font-weight-bold small" {...rest}>
      {children} {mandatory && mandatory === true && (
        <span className="text-red"> *</span>
      )}
    </Label>
  );
};